import React, { useState } from "react";
import "./Chatbot.css";
import { chatbot } from "../../assets/icons";

const Chatbot = ({ setChat }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const handleUserInput = () => {
    const userMessage = { text: input, user: "user" };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    const handleKeywordResponses = (input) => {
      const lowercasedInput = input.toLowerCase();

      if (/hi|hello|hey/.test(lowercasedInput)) {
        return "Hey there! Welcome to Zivotix! How can we assist you today? You can type 'services' to learn about our offerings.";
      }

      if (lowercasedInput.includes("services")) {
        return "Great choice! We offer web development, digital marketing, and 3D modeling services. What are you interested in? For example, you can ask about 'web development' or 'digital marketing'.";
      }

      if (lowercasedInput.includes("web development")) {
        return "Fantastic! Our web development services include creating modern and responsive websites tailored to your business needs. What specific features are you looking for? You can also inquire about 'digital marketing' or '3D modeling'.";
      }

      if (lowercasedInput.includes("digital marketing")) {
        return "Excellent! In digital marketing, we specialize in SEO, social media marketing, and online advertising to boost your online presence. Interested in a specific strategy? You can also ask about 'web development' or '3D modeling'.";
      }

      if (lowercasedInput.includes("3d modeling")) {
        return "Amazing! For 3D modeling, our team can create realistic and detailed models for various purposes, including architectural visualization and product design. Have a specific project in mind? Feel free to ask about 'web development' or 'digital marketing' too.";
      }

      return "I'm sorry, I didn't understand that. How can we assist you? You can explore our services by typing 'services'.";
    };

    const chatbotResponse = handleKeywordResponses(input);

    setMessages((prevMessages) => [
      ...prevMessages,
      { text: chatbotResponse, user: "chatbot" },
    ]);

    setInput("");
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        <div className="ZiBot">
          <img src={chatbot} alt="" className="zibot-img" />
          <div className="zibot-text">
            <span className="zibot-name">ZBot</span>
            <span className="zivotix">Zivotix</span>
          </div>
        </div>
        <span className="close-chat" onClick={() => setChat(false)}>
          X
        </span>
      </div>
      <div className="chat-content">
        <div id="chatContainer">
        <div className="say-hi">
          <span className="Hello-text">Type 'Hi' to start</span>
        </div>
        <div>
          {messages.map((msg, index) => (
            <div
              key={index}
              className={msg.user === "user" ? "userMessage" : "chatbotMessage"}
            >
              {console.log("msg", msg, "msg.user", msg.user)}
              {msg.user === "user" ? `Me: ${msg.text}` : `ZBot: ${msg.text}`}
            </div>
          ))}
        </div>
        </div>
        
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          id="input"
          autoComplete="off"
        />
        <button onClick={handleUserInput} id="chat-button">
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
